import { isArray } from '@ember/array';
import { typeOf } from '@ember/utils';
import { camelize as camelizeString, underscore as underscoreString } from '@ember/string';
export function transformData(data, transform) {
  switch (typeOf(data)) {
    case 'array':
      return data.map(item => transformData(item, transform));
    case 'object':
      {
        const out = {};
        forOwnProperty(data, (key, value) => {
          out[transform(key)] = transformData(value, transform);
        });
        return out;
      }
    default:
      return data;
  }
}
export function camelize(data) {
  return transformData(data, camelizeString);
}
export function underscore(data) {
  return transformData(data, key => {
    if (/[A-Z].*\d+$/.test(key)) {
      // Multiple words followed by a number
      return underscoreString(key.replace(/([a-z])(\d+)/g, '$1_$2'));
    } else {
      return underscoreString(key);
    }
  });
}

/** @deprecated - use `{ ...splat }` or `Object.assign()` or deep merge (e.g. `lodash-es/merge`) */
export function extend(deep, target, ...sources) {
  if (deep !== true && deep !== false) {
    return extend(false, deep, target, ...sources);
  }
  for (const source of sources) {
    if (source) {
      forOwnProperty(source, (key, value) => {
        /* eslint-disable no-param-reassign */
        if (deep && typeOf(value) === 'object') {
          target[key] = extend(true, {}, target[key], value);
        } else if (deep && typeOf(value) === 'array') {
          target[key] = value.map(item => extend(true, {}, {
            item
          }).item);
        } else {
          target[key] = value;
        }
        /* eslint-enable no-param-reassign */
      });
    }
  }
  return target;
}
export function checker(...validKeys) {
  if (validKeys.length === 1 && isArray(validKeys[0])) {
    validKeys = validKeys[0]; // eslint-disable-line no-param-reassign
  }
  return {
    check(object) {
      forOwnProperty(object, key => {
        if (!validKeys.includes(key)) {
          throw new Error(`unexpected key: ${key}`);
        }
      });
    }
  };
}
function forOwnProperty(object, iterator) {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      iterator(key, object[key]);
    }
  }
}